import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbChaveVirtualAcesso } from 'app/abstract/full-pages/chave-virtual-acesso/chave-virtual-acesso.abstract';
import {
  ChaveVirtualResponse,
  ChaveVirtualUpdateRequest
} from './chave-virtual-acesso.models';

const ENDPOINT = 'api/v1/chave-virtual';

@Injectable({ providedIn: 'root' })
export class ChaveVirtualAcessoService extends AbChaveVirtualAcesso {

  constructor(http: HttpClient) {
    super(http);
  }

  public buscar(): Observable<ChaveVirtualResponse> {
    return this.get<ChaveVirtualResponse>(ENDPOINT);
  }

  public atualizar(
    request: ChaveVirtualUpdateRequest
  ): Observable<ChaveVirtualResponse> {
    return this.http.put<ChaveVirtualResponse>(`${this.url}${ENDPOINT}`, request);
  }
}
